import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach JWT from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("suhool_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fmtPrice = (n) => `$${Number(n).toFixed(2)}`;

export function apiError(detail) {
  if (detail == null) return "حدث خطأ، حاول مجدداً.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export const COUNTRY_META = {
  PS: { name: "فلسطين", flag: "🇵🇸" },
};

// Authentic Palestinian terrains used as geographic SOURCE tags (not store sections)
export const GEO_META = {
  nablus_mt:     { name_ar: "جبال نابلس",   terrain: "mountain", primary: true },
  jerusalem_mt:  { name_ar: "جبال القدس",   terrain: "mountain", primary: false },
  hebron_mt:     { name_ar: "جبال الخليل",   terrain: "mountain", primary: false },
  ramallah_mt:   { name_ar: "جبال رام الله", terrain: "mountain", primary: false },
  salfit_mt:     { name_ar: "جبال سلفيت",   terrain: "mountain", primary: false },
  tulkarm_hills: { name_ar: "تلال طولكرم",  terrain: "hill",     primary: false },
  jenin_hills:   { name_ar: "تلال جنين",    terrain: "hill",     primary: false },
};

export const FLAVOR_LABELS = {
  sharp: "حاد", sweet: "حلو", salty: "مالح", herbal: "عشبي",
  earthy: "ترابي", fruity: "فاكهي", rich: "غني",
};
